/*
 * Put-address.ts
 * Description: Includes the declaration of a function
 * for updating the address
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing address interface
import {Address} from '@/ts/profile/addresses/validate-address';

/**
 * Updating an address
 *
 * @param {Number} id - id of an address
 * @param {Address} data - address data
 * @return {Object} Promise - when the request is resolved
 */
export function putAddress(id: number, data: Address) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'addresses/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
